import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import MyPortfolios from './MyPortfolios';
import ComparePortfoliosPage from '../../pages/portfolio/ComparePortfoliosPage';
import PortfolioComparisonPage from '../../pages/portfolio/PortfolioComparisonPage';
import { setStoredPortfolioAccountId } from '../../pages/portfolio/portfolioAccountStorage';

const LegacyPortfolioOverviewRedirect = () => {
  const { accountId } = useParams<{ accountId: string }>();

  useEffect(() => {
    if (accountId) {
      setStoredPortfolioAccountId(accountId);
    }
  }, [accountId]);

  return <Navigate to="/portfolio" replace />;
};

const PortfoliosRoutes = () => {
  return (
    <Routes>
      <Route index element={<MyPortfolios />} />
      <Route path="compare" element={<ComparePortfoliosPage />} />
      <Route path="compare/view" element={<PortfolioComparisonPage />} />
      <Route path=":accountId/overview" element={<LegacyPortfolioOverviewRedirect />} />
      <Route path="*" element={<Navigate to="/profile/portfolios" replace />} />
    </Routes>
  );
};

export default PortfoliosRoutes;
